import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Wallet } from "lucide-react";
import { PACKS, fmt } from "@/data/packs";

export const HomeIncome = () => (
  <section data-testid="home-income" className="bg-[var(--oz-bg-2)] border-b border-[var(--oz-border)]">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-14 sm:py-16 grid lg:grid-cols-[1fr_1.4fr] gap-10 items-center">
      <div>
        <p className="inline-flex items-center gap-2 text-[11px] sm:text-xs font-semibold uppercase tracking-[0.22em] text-[var(--oz-gold)]">
          <Wallet className="w-4 h-4" /> Revente
        </p>
        <h2 data-testid="home-income-title" className="mt-4 font-serif text-3xl sm:text-4xl leading-tight">Je veux un complément de revenu</h2>
        <p className="mt-4 text-sm sm:text-base text-[var(--oz-muted)] leading-relaxed">
          Vous n'êtes pas professionnel de la coiffure ? Revendez les soins Ozentya autour de vous grâce à nos packs de revente prêts à l'emploi, de 10 à 30 produits.
        </p>
        <Link to="/packs#packs" data-testid="home-income-cta"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-[var(--oz-dark)] text-white px-6 py-3 text-sm font-semibold hover:bg-[var(--oz-gold)] hover:text-[var(--oz-dark)] transition-colors">
          Voir les packs de revente <ArrowRight className="w-4 h-4" />
        </Link>
        <p className="mt-3 text-xs text-[var(--oz-muted)]">Aucun revenu n'est garanti : vos résultats dépendent de vos ventes.</p>
      </div>
      <div className="grid grid-cols-3 gap-3 sm:gap-4">
        {PACKS.map((p) => (
          <Link key={p.id} to="/packs#packs" data-testid={`home-income-pack-${p.slug}`}
            className={`group rounded-2xl bg-white border overflow-hidden transition-transform hover:-translate-y-1 ${p.highlight ? "border-[var(--oz-gold)] ring-1 ring-[var(--oz-gold)]" : "border-[var(--oz-border)]"}`}>
            <div className="aspect-square overflow-hidden bg-[var(--oz-bg-2)]">
              <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-3 sm:p-4">
              <p className="font-semibold text-xs sm:text-sm leading-tight">{p.name}</p>
              <p className="text-[11px] sm:text-xs text-[var(--oz-muted)]">{p.tagline}</p>
              <p className="mt-1 font-serif text-lg sm:text-xl">{fmt(p.price)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);
